export default __webpack_public_path__ + "static/media/14_photo.6d9262c9.jpg";